import { Box, Button, Heading, Link, Text } from '@chakra-ui/react'
import { ArrowRightIcon } from '@phosphor-icons/react'
import { FC } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Widget } from '../../components/Widget'
import { env } from '../../config/env'
import { ApplicantModel } from '@/lib/api/applicant.model'

type IntroBoxProps = {
  applicant?: ApplicantModel
}

export const IntroBox: FC<IntroBoxProps> = ({ applicant }) => {
  const { t } = useTranslation()

  return (
    <Widget
      width={'full'}
      display={'flex'}
      flexDir={'column'}
      justifyContent={'space-between'}
      backgroundImage={{
        base: '',
        md: 'url(/lady.png)',
      }}
      backgroundRepeat={'no-repeat'}
      backgroundPosition={'right center'}
      backgroundSize={'contain'}
    >
      <Box width={'full'}>
        <Heading
          fontSize={{
            base: '3xl',
            md: '4xl',
            lg: '5xl',
          }}
          variant={'widget'}
        >
          {t('applicationInformationPage.title')}
        </Heading>
        <Text
          maxW={'80ch'}
          // variant={'widget'}
          textStyle="widget"
          fontSize={{
            base: 'md',
          }}
        >
          <Trans
            i18nKey={'applicationInformationPage.description'}
            components={{
              note: <Text as={'span'} display={'block'} mt={4} />,
              important: <Text as={'span'} fontWeight={'bold'} color={'red.600'} />,
              changesLink: (
                <Link
                  rel={'noopener noreferrer'}
                  target={'_blank'}
                  href="https://www.tannlegeforeningen.no/arkiv/nyhetsarkiv/nyheter/2026-09-11-endringer-i-sykehjelpsordningens-vedtekter.html"
                />
              ),
            }}
          />
        </Text>
        {!applicant && <Text textStyle="widget">{t('applicationInformationPage.button.description')}</Text>}
        <Box
          display={'flex'}
          gap={{
            base: 4,
            md: 2,
          }}
          flexDir={{
            base: 'column',
            md: 'row',
          }}
        >
          {!applicant && (
            <Button variant={'bankid'} textDecoration={'none'} asChild width={{ base: 'fit-content', md: 'auto' }}>
              <Link href={env.VITE_BANK_ID_LOGIN_URL}>
                {t('applicationInformationPage.button.text')}
                <ArrowRightIcon />
              </Link>
            </Button>
          )}
          {/* Commented out before Go-live, change is requested. */}
          {/* <Button */}
          {/*   width={{ */}
          {/*     base: 'full', */}
          {/*     md: 'auto', */}
          {/*   }} */}
          {/*   colorScheme={'facebook'} */}
          {/*   as={RouterLink} */}
          {/*   to={applicationEligibilityRoute.to} */}
          {/* > */}
          {/*   {t('applicationInformationPage.checkEligibility')} */}
          {/* </Button> */}
        </Box>
      </Box>
      <Link
        mt={6}
        rel={'noopener noreferrer'}
        target={'_blank'}
        href="https://www.tannlegeforeningen.no/jus-og-arbeidsliv/ved-sykdom-og-svangerskap-/sykehjelpsordningen.html"
        width={'fit-content'}
        fontSize={{
          base: 'md',
        }}
      >
        {t('applicationInformationPage.link.text')}
      </Link>
    </Widget>
  )
}
